// @flow
import React from 'react';
import styled from 'styled-components';
import { Label } from 'semantic-ui-react';

// A small pill-shaped badge that pairs an icon with a bit of text. The colors are fixed (and the
// same regardless of the light/dark theme) so the badge reads consistently wherever it is used.
const StyledBadge = styled(Label)`
  &&&.ui.label {
    border: 0.5px solid #f4bf2f;
    background-color: #f9f0d7;
    color: #4c3801;
  }
`;

export const Badge = ({ icon, text }) => (
  <StyledBadge>
    {icon}
    {text}
  </StyledBadge>
);
